import React from 'react';

// Prikazuje komentar programera svugde po aplikaciji gde treba

const Komentar = (props) => {
  let cl = "";
  if (props.extraClass) {
    cl += " " + props.extraClass;
  }
  return (
    <div className={("dev-komentar" + cl)}><div className="dev-komentar__title">Komentar programera</div><div className="dev-komentar__content-container">{props.children}</div></div>
  );
};

export default Komentar;
